// extracted by mini-css-extract-plugin
export var carrierIcon = "_xe-0";
export var carrierLogo = "_xe-1";
export var detailsSection = "_xe-2";